<template>
  <div class="week-month-usage-wrap gap-3">
    <div class="flex-1 usage-card">
      <Usage :line-chart-data="weekData">
        <div class="title-wrap">
          <span style="">Total Usage</span>
          <span>Week</span>
        </div>
        <span class="usage-value">250S</span>
      </Usage>
    </div>

    <div style="flex:1.2" class="usage-card">
      <Usage :line-chart-data="monthData" :x-axis="monthAxis">
        <div class="title-wrap">
          <span style="">Total Usage</span>
          <span>Month</span>
        </div>
        <span class="usage-value">250S</span>
      </Usage>
    </div>

  </div>
</template>

<script>
import Usage from "@/components/Usage.vue";

export default {
  name: "WeekMonthUsage",
  components: { Usage },
  data() {
    return {
      monthData: [100, 100, 100, 299, 300, 400, 500],
      weekData: [100, 100, 100, 299, 300, 400, 500],
      monthAxis: {
        data: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"]
      }
    };
  },
  methods: {},
  mounted() {

  }
};
</script>

<style scoped lang="less">
.week-month-usage-wrap {
  display: flex;
  flex-direction: row;

}

.usage-card {
  border-radius: 12px;
  background: white;
  padding: 10px;
}

.usage-value {
}
</style>